import _ from "underscore";

import React from 'react';
import PropTypes from 'prop-types';

import Styles from './../StyleSheet';

class TerminalNameTerminal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      displayName: props.displayName || this._terminalData().displayName
    };

    this.remove = this.remove.bind(this);
  }

  render() {
    return (
      <div className="terminal" style={this._styles()}>
        {this.state.displayName}
        <i
          className="material-icons js-remove-terminal"
          onClick={this.remove}
          style={this._buttonStyles()}
        >close</i>
      </div>
    );
  }

  remove(event) {
    this.props.remove(this.props.node, event);
  }

  _terminalData() {
    return this.props.metaData;
  }

  isLastChild() {
    return (
      this._terminalData() && this._terminalData().type === 'boolean' || this.props.node.isNotTerminal()
    );
  }

  _styles() {
    return (
      _.extend(
        {},
        this.isLastChild() ? Styles.lastChild : undefined
      )
    );
  }

  _buttonStyles() {
    return (
      _.extend(
        {},
        this.props.editable ? undefined : Styles.hidden
      )
    );
  }
}

TerminalNameTerminal.propTypes = {
  node: PropTypes.object.isRequired,
  remove: PropTypes.func,
  displayName: PropTypes.string,
  metaData: PropTypes.object
};

export default TerminalNameTerminal;
